/* KWD chat window (2026-10-18). Talks to the kwd-chat Cloudflare Worker, which runs Claude
   Sonnet with the store's live catalog. The chat (ids, messages, cards) lives in localStorage
   so it follows the shopper from page to page. Add-to-cart uses /cart/add.js; kwd-header.js
   already hooks fetch, so the header chip, cart panel and sound all update by themselves. */
(function () {
  'use strict';
  /* Same file on KWD and WBTC; the snippet sets the per-store bits as data- attributes on #kwdchat. */
  var root = document.getElementById('kwdchat');
  if (!root || root.getAttribute('data-ready')) return;
  var D = root.dataset;
  var API = D.api || 'https://kwd-chat.kosherwinedirect.workers.dev';
  var KEY = (D.key || 'kwdchat') + ':v1', VKEY = (D.key || 'kwdchat') + ':visitor';
  // Preview switch: with data-preview="1" on #kwdchat (set in the store's snippet) the chat shows only
  // after visiting with ?kwdchat=preview (remembered in this browser; ?kwdchat=off clears it).
  var PREVIEW_ONLY = D.preview === '1';
  try {
    if (/[?&]kwdchat=preview/.test(location.search)) localStorage.setItem('kwdchat:preview', '1');
    if (/[?&]kwdchat=off/.test(location.search)) localStorage.removeItem('kwdchat:preview');
    if (PREVIEW_ONLY && !localStorage.getItem('kwdchat:preview')) return;
  } catch (e) { if (PREVIEW_ONLY) return; }
  root.setAttribute('data-ready', '1');

  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function rid() { var a = new Uint8Array(12); (window.crypto || {}).getRandomValues ? crypto.getRandomValues(a) : a.forEach(function (_, i) { a[i] = Math.random() * 256; }); return Array.prototype.map.call(a, function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var visitor = store(VKEY) || rid(); store(VKEY, visitor);
  var state = store(KEY) || null;
  function fresh() { state = { id: rid(), msgs: [], status: 'open' }; save(); }
  function save() { store(KEY, state); }
  if (!state || !state.id || !Array.isArray(state.msgs)) fresh();
  var cart = null, busy = false;

  var CHIPS = (D.chips || 'Under $20|For Shabbos|A gift|Dry red|Something sweet|Shipping').split('|');
  var GREET = "Hi! Tell me what you're looking for: an occasion, a budget, a grape. I'll pull the bottles for you.";

  /* Inline mode: a page section with [data-kwdchat-inline] (the WBTC homepage) gets the chat window built
     into the page, always open, and no floating button on that page. Same conversation as the floating one. */
  var host = document.querySelector('[data-kwdchat-inline]'), INLINE = !!host;
  if (INLINE) host.appendChild(root);
  root.className = 'kwdchat' + (INLINE ? ' inline' : '');
  root.innerHTML =
    '<button class="kwdchat-launch" type="button" aria-label="Open wine chat"><span class="orb"><svg viewBox="0 0 24 24" fill="none" stroke="#3a0918" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg></span>Ask about any bottle</button>' +
    '<div class="kwdchat-dim"></div>' +
    '<div class="kwdchat-panel" role="dialog" aria-label="Wine help chat">' +
      '<div class="kwdchat-grab"></div>' +
      '<div class="kwdchat-hd"><div class="kwdchat-mark"></div>' +
        '<div class="kwdchat-t"><h3>' + esc(D.title || 'Kosher Wine Direct') + '</h3><div class="kwdchat-s"><i></i>Agentic Shopify, powered by Claude Sonnet</div></div>' +
        '<button class="kwdchat-btn kwdchat-x" type="button" aria-label="Close chat"></button></div>' +
      '<div class="kwdchat-body" aria-live="polite"></div>' +
      '<div class="kwdchat-foot"><div class="kwdchat-chips"></div>' +
        '<form class="kwdchat-inp"><input type="text" maxlength="1500" autocomplete="off" placeholder="Ask about a wine, a price, a gift…" aria-label="Your message">' +
        '<button class="kwdchat-send" type="submit" aria-label="Send"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button></form>' +
        '<button type="button" class="kwdchat-new">Start a new chat</button></div>' +
    '</div>';

  var body = root.querySelector('.kwdchat-body'), chips = root.querySelector('.kwdchat-chips');
  var form = root.querySelector('.kwdchat-inp'), input = form.querySelector('input'), sendBtn = form.querySelector('.kwdchat-send');
  var foot = root.querySelector('.kwdchat-foot');

  /* light formatting for the bot's text: paragraphs, "- " lists, **bold**, our own links */
  function fmt(t) {
    var out = [], list = null;
    String(t).split(/\n/).forEach(function (line) {
      var h = esc(line).replace(/\*\*(.+?)\*\*/g, '<b>$1</b>')
        .replace(/(https:\/\/(?:www\.)?kosherwinedirect\.com\/[^\s<)]*)/g, '<a href="$1">$1</a>');
      if (/^\s*[-•*]\s+/.test(line)) { if (!list) { list = []; } list.push('<li>' + h.replace(/^\s*[-•*]\s+/, '') + '</li>'); return; }
      if (list) { out.push('<ul>' + list.join('') + '</ul>'); list = null; }
      if (line.trim()) out.push('<p>' + h + '</p>');
    });
    if (list) out.push('<ul>' + list.join('') + '</ul>');
    return out.join('');
  }

  function cardHTML(c) {
    var price = String(c.price || '').replace('$', '');
    var added = (state.added || []).indexOf(c.variant_id) > -1;
    return '<div class="kwdchat-card"><a class="ph" href="' + esc(c.url) + '">' + (c.image ? '<img loading="lazy" alt="" src="' + esc(c.image) + (c.image.indexOf('?') > -1 ? '&' : '?') + 'width=300">' : '') + '</a>' +
      '<a class="nm" href="' + esc(c.url) + '">' + esc(String(c.title || '').replace(/\s*\((?:750|1\.5|375)\s*ml\)\s*$/i, '')) + '</a>' +
      '<div class="row"><div class="pr">$' + esc(price) + '</div><button type="button" class="kwdchat-add' + (added ? ' done' : '') + '" data-v="' + esc(c.variant_id) + '" data-t="' + esc(c.title) + '" aria-label="Add ' + esc(c.title) + ' to cart">' + (added ? '&#10003;' : '+') + '</button></div></div>';
  }

  function render() {
    var h = '<div class="kwdchat-msg bot">' + fmt(GREET) + '</div>';
    state.msgs.forEach(function (m) {
      h += '<div class="kwdchat-msg ' + (m.role === 'user' ? 'me' : 'bot') + '">' + (m.role === 'user' ? esc(m.content) : fmt(m.content)) + '</div>';
      if (m.cards && m.cards.length) h += '<div class="kwdchat-cards">' + m.cards.map(cardHTML).join('') + '</div>';
    });
    if (state.status === 'ended') h += '<div class="kwdchat-note">This chat has ended.</div>';
    if (state.status === 'blocked') h += '<div class="kwdchat-note">Chat isn\'t available right now. You can still browse and check out as usual.</div>';
    body.innerHTML = h;
    var closed = state.status !== 'open';
    form.style.display = closed ? 'none' : '';
    chips.style.display = closed || state.msgs.length > 2 ? 'none' : '';
    var rs = foot.querySelector('.kwdchat-restart');
    if (state.status === 'ended' && !rs) foot.insertAdjacentHTML('beforeend', '<button type="button" class="kwdchat-restart">Start a new chat</button>');
    if (state.status !== 'ended' && rs) rs.remove();
    root.querySelector('.kwdchat-new').style.display = state.status === 'open' && state.msgs.length ? '' : 'none';
    body.scrollTop = body.scrollHeight;
  }
  chips.innerHTML = CHIPS.map(function (c) { return '<button type="button" class="kwdchat-chip">' + esc(c) + '</button>'; }).join('');

  function cartSummary() {
    if (!cart) return null;
    return { count: cart.item_count || 0, total: (cart.total_price || 0) / 100,
      items: (cart.items || []).slice(0, 20).map(function (i) { return i.quantity + ' x ' + i.product_title; }) };
  }
  function loadCart() { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cart = c; }).catch(function () {}); }
  document.addEventListener('kwd:cart:updated', function (e) { if (e.detail && e.detail.cart) cart = e.detail.cart; });
  /* Stamp the cart with this chat's id once the shopper has talked to us. Shopify carries cart
     attributes onto the order, and the leading _ keeps it out of sight at checkout; pull_chats.py
     matches orders back to chats by it. */
  function stamp() {
    if (!cart || !state.msgs.length || (cart.attributes || {})._kwdchat === state.id) return;
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _kwdchat: state.id } }) })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (c) { if (c) cart = c; }).catch(function () {});
  }
  /* kwd-cart.js pops the cart sheet on every add; for adds made from a chat card keep the shopper in
     the chat. Capture on window runs before the document listeners, so retagging the reason is enough. */
  var chatAddUntil = 0;
  window.addEventListener('kwd:cart:updated', function (e) {
    if (e.detail && e.detail.reason === 'add' && Date.now() < chatAddUntil) { e.detail.reason = 'chat-add'; chatAddUntil = 0; }
  }, true);

  function send(text) {
    text = String(text || '').trim();
    if (!text || busy || state.status !== 'open') return;
    busy = true; sendBtn.disabled = true;
    state.msgs.push({ role: 'user', content: text.slice(0, 1500) }); save(); render();
    body.insertAdjacentHTML('beforeend', '<div class="kwdchat-typing"><span></span><span></span><span></span></div>');
    body.scrollTop = body.scrollHeight;
    var payload = { chat_id: state.id, visitor_id: visitor, page: location.pathname,
      messages: state.msgs.map(function (m) { return { role: m.role, content: m.content }; }) };
    (cart ? Promise.resolve() : loadCart()).then(function () {
      payload.cart = cartSummary(); stamp();
      return fetch(API + '/api/chat', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (d) {
        if (d.blocked) { state.status = 'blocked'; if (d.reply) state.msgs.push({ role: 'assistant', content: d.reply }); }
        else if (d.ended && !d.reply) { state.status = 'ended'; }
        else if (d.ok && d.reply) {
          state.msgs.push({ role: 'assistant', content: d.reply, cards: d.cards || [] });
          if (d.ended) state.status = 'ended';
        } else {
          state.msgs.pop();
          body.insertAdjacentHTML('beforeend', '<div class="kwdchat-note">' + (d.error === 'slow_down' ? 'One moment, then try again.' : 'That didn\'t go through. Try again in a moment.') + '</div>');
          input.value = text;
        }
      })
      .catch(function () { state.msgs.pop(); input.value = text; })
      .then(function () {
        busy = false; sendBtn.disabled = false; save();
        var note = body.querySelector('.kwdchat-note:last-child'); render(); if (note && state.status === 'open') body.appendChild(note);
        if (state.status === 'open' && window.matchMedia('(min-width:641px)').matches) input.focus();
      });
  }

  function addToCart(btn) {
    var v = btn.getAttribute('data-v'); if (!v || btn.classList.contains('done')) return;
    btn.classList.add('busy');
    chatAddUntil = Date.now() + 4000;
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +v, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; btn.classList.remove('busy'); btn.classList.add('done'); btn.innerHTML = '&#10003;';
        if (D.cartEvent) fetch('/cart.js', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (c) {
          try { document.dispatchEvent(new CustomEvent(D.cartEvent, { detail: c })); } catch (e) {} }).catch(function () {});
        state.added = (state.added || []).concat(v); save();
        fetch(API + '/api/event', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ chat_id: state.id, type: 'add', variant_id: v, title: btn.getAttribute('data-t') }) }).catch(function () {});
        loadCart().then(stamp); })
      .catch(function () { btn.classList.remove('busy'); });
  }

  var orbLoaded = false;
  function loadOrb() {
    if (orbLoaded) return; orbLoaded = true;
    var src = root.getAttribute('data-orb'); if (!src) return;
    var s = document.createElement('script'); s.src = src; s.async = true;
    s.onload = function () { if (window.KWDChatOrb) window.KWDChatOrb(root.querySelector('.kwdchat-mark')); };
    document.head.appendChild(s);
  }

  /* the subtitle must stay on one line: shrink it a little on very narrow phones */
  function fitSub() {
    var el = root.querySelector('.kwdchat-s'); el.style.fontSize = '';
    var px = parseFloat(getComputedStyle(el).fontSize);
    while (el.scrollWidth > el.clientWidth && px > 8.5) { px -= 0.25; el.style.fontSize = px + 'px'; }
  }
  window.addEventListener('resize', function () { if (root.classList.contains('on')) fitSub(); });

  function open() { loadOrb(); render(); root.classList.add('on'); fitSub(); loadCart();
    if (INLINE) return;
    if (window.matchMedia('(min-width:641px)').matches) setTimeout(function () { input.focus(); }, 300);
    if (window.matchMedia('(max-width:640px)').matches) document.documentElement.style.overflow = 'hidden'; }
  function close() { if (INLINE) return; root.classList.remove('on'); document.documentElement.style.overflow = ''; }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('.kwdchat-launch')) return open();
    if (t.closest('.kwdchat-x') || t.closest('.kwdchat-dim')) return close();
    if (t.closest('.kwdchat-new') || t.closest('.kwdchat-restart')) { if (state.status === 'blocked') return; fresh(); render(); return; }
    var chip = t.closest('.kwdchat-chip'); if (chip) return send(chip.textContent);
    var add = t.closest('.kwdchat-add'); if (add) return addToCart(add);
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; send(v); });
  /* the in-page "Ask about any bottle" section calls this: opens the chat and sends the question */
  window.KWDChatAsk = function (text) {
    if (state.status !== 'open') { if (state.status === 'blocked') return open(); fresh(); }
    open(); send(text);
  };
  document.documentElement.classList.add('kwdchat-on');
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('on')) close(); });
  if (INLINE) {
    render(); root.classList.add('on'); fitSub();
    /* the orb and cart load when the section comes near the screen, not on page load */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); loadOrb(); loadCart(); } }, { rootMargin: '600px' });
      io.observe(host);
    } else { loadOrb(); loadCart(); }
  } else if (state.msgs.length && state.reopen && window.matchMedia('(min-width:641px)').matches) open();
  window.addEventListener('pagehide', function () { if (!INLINE) state.reopen = root.classList.contains('on'); save(); });
})();
